import React from 'react'
import ContriveForm from "./ContriveForm"
import Navbar from '../../../components/Navbar'
import Footer from '../../../components/footer'
const InventivePage = () => {
  return (
    <div  >
        <Navbar/>
      <ContriveForm/>
      <Footer/>
    </div>
  )
}

export default InventivePage
